import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { AuthActions } from "@app/auth/store";
import { ComponentCanDeactivate, PendingChangesGuard } from "@app/project/services/pending-changes.guard";
import { RootStoreState } from "@app/root-store";
import { MatIconLoaderService } from "@app/shared/services/mat-icon-loader.service";
import { User } from "@app/user/model/user";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

@Component({
    selector: "app-sidenav",
    templateUrl: "./sidenav.component.html",
    styleUrls: ["./sidenav.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent implements ComponentCanDeactivate {
    @Input() user: User;
    @Input() isMobile: boolean;

    private readonly icons = [
        [`cc-dashboard`, `dashboard`],
        [`cc-projects`, `projects`],
        [`cc-staff`, `staff`],
        [`cc-dealers`, `dealers`],
        [`cc-help`, `help`],
        [`cc-settings`, `settings`],
        [`cc-new`, `whats_new`],
    ];
    warningDialogConfig = {
        title: "Leave Page",
    };

    canDeactivate(): Observable<boolean> | boolean {
        this.warningDialogConfig.title = `Leave Page`;
        // returning true will navigate without confirmation
        // returning false will show a confirm dialog before navigating away
        return false;
    }

    constructor(
        private store: Store<RootStoreState.State>,
        matIconLoader: MatIconLoaderService,
        private readonly pendingChangesGuard: PendingChangesGuard
    ) {
        matIconLoader.importIcons(this.icons);
    }

    logout() {
        this.store.dispatch(AuthActions.logOutConfirmation());
    }
    private signOut() {
        this.store.dispatch(AuthActions.logOutConfirmation());
    }
}
